import { render, staticRenderFns } from "./DialogEditLaw.vue?vue&type=template&id=51793cd0&scoped=true"
import script from "./DialogEditLaw.vue?vue&type=script&lang=js"
export * from "./DialogEditLaw.vue?vue&type=script&lang=js"
import style0 from "./DialogEditLaw.vue?vue&type=style&index=0&id=51793cd0&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51793cd0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51793cd0')) {
      api.createRecord('51793cd0', component.options)
    } else {
      api.reload('51793cd0', component.options)
    }
    module.hot.accept("./DialogEditLaw.vue?vue&type=template&id=51793cd0&scoped=true", function () {
      api.rerender('51793cd0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DialogEditLaw.vue"
export default component.exports